export const getAgeAtYearEnd = (dateStr, programYear) => {
  if (!dateStr) return null;

  const dob = new Date(dateStr);
  if (isNaN(dob.getTime())) return null; // invalid date check

  const year = Number(programYear);
  if (!Number.isInteger(year) || year <= 0) return null;

  const endOfYear = new Date(year, 11, 31); // 31/12 of the program year

  let age = endOfYear.getFullYear() - dob.getFullYear();
  if (
    endOfYear.getMonth() < dob.getMonth() ||
    (endOfYear.getMonth() === dob.getMonth() &&
      endOfYear.getDate() < dob.getDate())
  ) {
    age--;
  }

  return age;
};
